<template>
  <div>
    <v-container fluid class="mx-12 my-6">
      <div class="d-flex flex-row mb-4">
        <div class="card-label d-flex flex-row mb-4">
          <v-icon>mdi-cash-multiple</v-icon>
          <p class="mb-0 ml-4 subtitle-1 font-weight-bold">
            Create Multiple Payments
          </p>
        </div>
        <div class="flex-grow-1"></div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              depressed
              rounded
              color="primary"
              class="mr-2 font-weight-bold"
              @click="openCreateMultiplePaymentsDialog"
              v-on="on"
            >
              <v-icon class="pr-1">mdi-file-upload</v-icon>Import New File
            </v-btn>
          </template>
          <p style="color: white">
            Create batch payments by uploading a CSV File
          </p>
        </v-tooltip>
      </div>
      <v-card elevation="0" class="card-container px-8 py-4">
        <v-data-table
          fixed-header
          :items="payments"
          :headers="headers"
          height="450"
          disable-pagination
          disable-filtering
          disable-sort
          hide-default-footer
          dense
        >
          <template v-slot:item="{ item, index }">
            <tr v-if="item && item.valid">
              <td>
                <p class="caption">{{ index + 1 }}</p>
              </td>
              <td>
                <v-checkbox
                  v-model="item.selected"
                  hide-details
                  dense
                  class="mt-0"
                  @change="checkSelected"
                ></v-checkbox>
              </td>
              <td>
                <p class="caption">{{ item.unitId }}</p>
              </td>
              <td>
                <p class="caption">{{ item.unitName }}</p>
              </td>
              <td>
                <p class="caption">{{ item.period }}</p>
              </td>
              <td>
                <p class="caption">{{ item.dueDate }}</p>
              </td>
              <td>
                <p class="caption">{{ item.parsedCategory }}</p>
              </td>
              <td>
                <p class="caption">{{ item.description }}</p>
              </td>
              <td>
                <p class="caption">{{ item.parsedStatus }}</p>
              </td>
              <td>
                <p class="caption">{{ formatCurrency(item.total) }}</p>
              </td>
              <td>
                <p class="caption">{{ formatCurrency(item.amountPaid) }}</p>
              </td>
              <td>
                <p class="caption">{{ item.datePaid }}</p>
              </td>
            </tr>
            <tr v-else>
              <td>
                <p class="caption">{{ index + 1 }}</p>
              </td>
              <td colspan="11">
                <div class="d-flex justify-center">
                  <p class="grey--text">
                    {{ (item && item.message) || 'Invalid Entry' }}
                  </p>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            :disabled="!isValid"
            @click="finish"
            >Finish</v-btn
          >
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-container>
    <CreateMultiplePayments
      ref="createMultiplePayments"
    ></CreateMultiplePayments>
  </div>
</template>

<script>
import CreateMultiplePayments from '../components/payment/CreateMultiplePayments.vue'
export default {
  components: {
    CreateMultiplePayments
  },
  data() {
    return {
      payments: [],
      headers: [
        { value: 'index', text: 'Entry' },
        { value: 'select', text: 'Select' },
        { value: 'unitId', text: 'Unit ID' },
        { value: 'unitName', text: 'Unit Name' },
        { value: 'period', text: 'Period' },
        { value: 'dueDate', text: 'Due Date' },
        { value: 'parsedCategory', text: 'Category' },
        { value: 'description', text: 'Description' },
        { value: 'parsedStatus', text: 'Status' },
        { value: 'amount', text: 'Amount' },
        { value: 'amountPaid', text: 'Amount Paid' },
        { value: 'datePaid', text: 'Date Paid' }
      ],
      isValid: false
    }
  },
  mounted() {
    this.payments = this.$store.getters['payments/getPreviewMultiplePayments']
    this.checkSelected()
  },
  methods: {
    formatCurrency(value) {
      if (value == null) return ''
      // do not divide by 100. for display from CSV.
      return parseFloat(value).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    },
    checkSelected() {
      this.isValid = this.payments.filter((p) => p && p.selected).length
    },
    async finish() {
      if (
        await this.$root.$confirm({
          message: `Are you sure you want to create the payments?`,
          confirmText: 'Yes',
          options: {
            width: 400
          }
        })
      ) {
        this.$root.$setLoading(true)
        const result = await this.$store.dispatch(
          'payments/createMultiplePaymentsAction',
          {
            payments: this.payments
              .filter((p) => p && p.selected)
              .map((p) => {
                p.total = Math.round(p.total * 100)
                p.amountPaid = Math.round(p.amountPaid * 100)
                return p
              })
          }
        )
        if (result) {
          this.$root.$setLoading(false)
          this.$root
            .$confirm({
              title: 'Create Multiple Payments',
              message: `Successfully created payments`,
              reconfirmOnly: true,
              confirmText: 'OK',
              options: {
                color: 'primary'
              }
            })
            .then(() => {
              this.$router.replace('/payments')
            })
        }
      }
    },
    cancel() {
      this.$router.replace('/payments')
    },
    async openCreateMultiplePaymentsDialog() {
      const success = await this.$refs.createMultiplePayments.open()
      if (success) {
        this.payments =
          this.$store.getters['payments/getPreviewMultiplePayments']
        this.checkSelected()
      }
    }
  }
}
</script>
